import { AddOnFilterKey } from '../domain';
import { useSetFilter } from '../../filter';

export const useSetAddOnFilter = () => {
  return useSetFilter(AddOnFilterKey, 'addOnFilter', true);
};
